import { render, staticRenderFns } from "./recucler-bars-list.vue?vue&type=template&id=2faf39da&"
import script from "./recucler-bars-list.vue?vue&type=script&lang=ts&"
export * from "./recucler-bars-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports